export const formatTimeToISO = (d: number) => {
  if (!d) { return '' }
  return new Date(d).toISOString()
}
